import { render } from "./PartnerUsersList.vue?vue&type=template&id=8edd58c4"
import script from "./PartnerUsersList.vue?vue&type=script&lang=js"
export * from "./PartnerUsersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__